import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstancefc1kb6w5z78x as Companion_getInstance,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../LocalDate.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LocalDateIso8601SerializerClass;
function LocalDateIso8601Serializer() {
  if (LocalDateIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        LocalDateIso8601Serializer_instance = this;
        this.i25_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate', STRING_getInstance());
      }
      az() {
        return this.i25_1;
      }
      pz(decoder) {
        return Companion_getInstance().l25(decoder.h13());
      }
      m25(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.m25(encoder, value instanceof LocalDate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalDateIso8601Serializer', VOID, VOID, [KSerializer()]);
    LocalDateIso8601SerializerClass = $;
  }
  return LocalDateIso8601SerializerClass;
}
var LocalDateIso8601Serializer_instance;
function LocalDateIso8601Serializer_getInstance() {
  if (LocalDateIso8601Serializer_instance === VOID)
    new (LocalDateIso8601Serializer())();
  return LocalDateIso8601Serializer_instance;
}
//region block: exports
export {
  LocalDateIso8601Serializer_getInstance as LocalDateIso8601Serializer_getInstanceny1y5h6nyej8,
};
//endregion

//# sourceMappingURL=LocalDateSerializers.mjs.map
